/**
 * Image specifications shown in admin uploaders.
 * Helps the owner upload optimally sized images.
 */
export const IMAGE_SPECS = {
  hero: {
    label: 'Imagen de cabecera (hero)',
    width: 1920,
    height: 1080,
    ratio: '16:9',
    maxKB: 800,
    formats: 'JPG, WEBP',
    note: 'Imagen panorámica de gran calidad. Se mostrará a pantalla completa.',
  },
  experience_cover: {
    label: 'Portada de experiencia',
    width: 1600,
    height: 900,
    ratio: '16:9',
    maxKB: 600,
    formats: 'JPG, WEBP',
    note: 'Imagen del campo de golf o de la bodega. Formato horizontal.',
  },
  team_photo: {
    label: 'Foto del equipo',
    width: 800,
    height: 1000,
    ratio: '4:5 (vertical)',
    maxKB: 400,
    formats: 'JPG, WEBP',
    note: 'Retrato vertical con buena iluminación y fondo limpio.',
  },
  bodega_logo: {
    label: 'Logo de bodega / patrocinador',
    width: 600,
    height: 400,
    ratio: '3:2 o cuadrado',
    maxKB: 200,
    formats: 'PNG (con transparencia), WEBP',
    note: 'Fondo transparente preferible. Centra el logo en el lienzo.',
  },
  experience_attachment_image: {
    label: 'Imagen adjunta de experiencia',
    width: 1600,
    height: 1067,
    ratio: '3:2',
    maxKB: 500,
    formats: 'JPG, WEBP',
    note: 'Para álbumes de fotos o detalles del evento.',
  },
  document: {
    label: 'Documento PDF',
    maxKB: 5120,
    formats: 'PDF',
    note: 'Reglamentos, clasificaciones u otros documentos. Máximo 5 MB.',
  },
  general: {
    label: 'Imagen general',
    width: 1600,
    maxKB: 600,
    formats: 'JPG, PNG, WEBP',
    note: 'Imagen genérica.',
  },
};

export const renderSpec = (key) => {
  const s = IMAGE_SPECS[key] || IMAGE_SPECS.general;
  return s;
};
